import { PopupStorage } from '~helpers/PopupStorage/PopupStorage';
import {
  MappedPopupAction,
  mapPopupActionProps,
  StrapiPopupItem,
} from '~helpers/strapi/mapPopupActionProps';

function compareByLastShown(
  a: MappedPopupAction,
  b: MappedPopupAction,
): number {
  const entryA = PopupStorage.getPopupState(a.id);
  const entryB = PopupStorage.getPopupState(b.id);

  const hasBeenShownA = entryA?.lastShownAt != null;
  const hasBeenShownB = entryB?.lastShownAt != null;

  if (!hasBeenShownA && hasBeenShownB) return -1;
  if (hasBeenShownA && !hasBeenShownB) return 1;
  if (!hasBeenShownA && !hasBeenShownB) return 0;

  const timeA = entryA?.lastShownAt
    ? new Date(entryA.lastShownAt).getTime()
    : 0;
  const timeB = entryB?.lastShownAt
    ? new Date(entryB.lastShownAt).getTime()
    : 0;

  return timeA - timeB;
}

export function computeEligiblePopups(
  items: StrapiPopupItem[] | undefined,
): MappedPopupAction[] {
  if (!items?.length) return [];

  const eligible = items
    .map((item) => mapPopupActionProps(item))
    .filter((m): m is MappedPopupAction => m !== null)
    .filter((popup) => !PopupStorage.isPermanentlyDismissed(popup.id));

  return eligible.sort(compareByLastShown);
}
